import { cloneDeep } from "lodash";
import { applyPatch } from "rfc6902";
import { ArsContextState, IArsActionUndoChange } from "../interface";
import { extractDataState } from "./extractDataState";

/**
 * Moves the undo pointer backward and applies reverse patches.
 *
 * @param state - Current ARS context state
 * @param action - Undo action with optional step count
 * @returns Updated state after undo operations
 */
export const arsc_undoArsChange = <T>(
  state: ArsContextState<T>,
  action: IArsActionUndoChange,
): ArsContextState<T> => {
  const steps = action.steps ?? 1;
  const newIx = Math.max(-1, state.ixPatch - steps);

  if (newIx === state.ixPatch) {
    return state;
  }

  const currentState = cloneDeep(extractDataState(state));
  for (let i = state.ixPatch; i > newIx; i--) {
    const patch = state.patches[i];
    /* istanbul ignore else */
    if (patch) {
      applyPatch(currentState, patch.reverse);
    }
  }

  return {
    ...state,
    ...currentState,
    ixPatch: newIx,
  };
};
